<script>
import { mapActions, mapGetters } from "vuex";
// import store from "@/state/store";
import {
  required,
  //   between,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";

import Api from "../../../services/integrationApi";
import CustomStore from "devextreme/data/custom_store";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import PageHeader from "@/components/page-header";

import dublicateAction from "./dublicateAction";
// import DataTable from "@/components/grid/DataTable";
// import EditIntegModal from "@/components/integration/EditIntegrationModal";
// import SyncIntegModal from "@/components/integration/SyncIntegrationModal";
import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import "whatwg-fetch";

const dataGridRef = "dataGrid";

import DxDataGrid, {
  DxMasterDetail,
  DxColumn,
  // DxLookup,
  DxFilterRow,
  DxHeaderFilter,
  // DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxToolbar,
  DxItem,
  DxPaging,
  DxPager,
  // Button,
  // DxDropDownButton
  // DxGrouping,
  // DxGroupPanel,
  DxScrolling,
} from "devextreme-vue/data-grid";

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
export default {
  components: {
    Breadcrumb,
    PageHeader,
    // EditIntegModal,
    // DataTable,
    // SyncIntegModal,
    DxDataGrid,
    DxMasterDetail,
    DxColumn,
    // DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    // DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxToolbar,
    DxItem,
    Button,
    DxDropDownButton,
    DxScrolling,
    dublicateAction,
  },
  data() {
    return {
      rtlEnabled: false,
      nextLoading: false,
      isLoading: false,
      showClearAll: false,
      multipleFilters: [],
      userTypeHeaderFilter: [],
      totalCount: 0,
      sortObject: 0,
      finalFilterObject: 0,
      usersWithDuplicatesCount: 0,
      dataStore: new CustomStore({
        key: "id",
        load: (loadOptions) => {
          console.log("load fn from custom store fired");
          let params = "?";
          let filterQuery = "";
          console.log("filterQuery", filterQuery);
          let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ].forEach((i) => {
            console.log("forEach", i, loadOptions[i]);
            console.log("isnotempty", isNotEmpty(loadOptions[i]));
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              if (i == "filter") {
                console.log("loadOptions[i]", loadOptions[i]);
                filterQuery += `${JSON.stringify(loadOptions[i])}`;
              }
              if (i == "sort") {
                sortObject.sortField = loadOptions[i][0].selector;
                sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
              }
            }
          });
          // this.resetUsersData();
          console.log("1 params", params);
          params = params.slice(0, -1);
          console.log("2 params", params);
          let filters;
          let finalFilterObject = {};
          this.multipleFilters = [];
          if (filterQuery) filters = JSON.parse(filterQuery);
          if (filters) console.log("filters", filters);
          if (filters && typeof filters[0] === "string") {
            if (filters[0] == "!") {
              console.log("not");
              if (typeof filters[1] === "object") {
                const excludeIds = [];
                const columnHeader =
                  typeof filters[1][0] === "object"
                    ? filters[1][0][0] + "HeaderFilter"
                    : filters[1][0] + "HeaderFilter";
                const columnHeaderFilter =
                  columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
                console.log(columnHeaderFilter); // name of column filter
                if (typeof filters[1][0] === "object") {
                  console.log("obj");
                  filters[1].map((item) => {
                    if (typeof item === "object") {
                      console.log("item", item[2][0]);
                      excludeIds.push(item[2][0]);
                    }
                  });
                } else {
                  console.log("else");
                  // filters[1].map(item => {
                  // if (typeof item === "object") {
                  console.log("item", filters[1][2][0]);
                  excludeIds.push(filters[1][2][0]);
                  // }
                  // });
                }
                console.log(this[columnHeaderFilter]);
                const arr = this[columnHeaderFilter].filter(
                  (el) => !excludeIds.includes(el.value[2][0])
                );
                console.log("arr", arr, excludeIds);
                if (typeof filters[1][0] === "object") {
                  finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                } else {
                  finalFilterObject[filters[1][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                }
                console.log("finalFilterObject", finalFilterObject);
                // if (this.multipleFilters.length > 0) {
                this.multipleFilters.push(finalFilterObject);
                // }
              }
            } else {
              finalFilterObject[filters[0]] =
                filters[1] === "contains" || filters[1] === "="
                  ? filters[2]
                  : filters[2];
            }

            // if (this.multipleFilters.length > 0) {
            this.multipleFilters.push(finalFilterObject);
            // }
          } else {
            // const isOr = filters[1] === 'or';
            // const isAnd = filters[1] === 'and';
            if (filters)
              for (const filter of filters) {
                if (filter[0] == "!") {
                  // console.log('multiple filters not');
                  if (typeof filter[1] === "object") {
                    const excludeIds = [];
                    const columnHeader =
                      typeof filter[1][0] === "object"
                        ? filter[1][0][0] + "HeaderFilter"
                        : filter[1][0] + "HeaderFilter";
                    const columnHeaderFilter =
                      columnHeader.charAt(0).toLowerCase() +
                      columnHeader.slice(1);
                    console.log(columnHeaderFilter); // name of column filter
                    if (typeof filter[1][0] === "object") {
                      // console.log('obj');
                      filter[1].map((item) => {
                        if (typeof item === "object") {
                          // console.log('item', item[2][0]);
                          excludeIds.push(item[2][0]);
                        }
                      });
                    } else {
                      // console.log('else');
                      // filters[1].map(item => {
                      // if (typeof item === "object") {
                      // console.log('item', filter[1][2][0]);
                      excludeIds.push(filter[1][2][0]);
                      // }
                      // });
                    }
                    // console.log(this[columnHeaderFilter]);
                    const arr = this[columnHeaderFilter].filter(
                      (el) => !excludeIds.includes(el.value[2][0])
                    );
                    // console.log('arr', arr, excludeIds);
                    if (typeof filter[1][0] === "object") {
                      finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    } else {
                      finalFilterObject[filter[1][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    }
                    console.log("finalFilterObject", finalFilterObject);
                    this.multipleFilters.push(finalFilterObject);
                  }
                }
                let orExist;
                let andExist;
                if (typeof filter === "object") {
                  console.log("obj", filter);
                  orExist = filter.find((item) => item === "or");
                  andExist = filter.find((item) => item === "and");
                  if (filter[1] == "or") {
                    // Header Filter - Gather In One Condition
                    if (
                      filter[0][1] === ">=" ||
                      filter[0][1] === "<=" ||
                      filter[0][1] === "<"
                    ) {
                      const finalFilter = {};
                      const condition = [];
                      for (const filterItem of filter) {
                        if (filterItem[2]) condition.push(filterItem[2][0]);
                      }
                      finalFilter[filter[0][0]] = {
                        start: condition[0].replace(/\//g, "-"),
                        end: condition[1].replace(/\//g, "-"),
                      };
                      this.multipleFilters.push(finalFilter);
                    } else {
                      // Gather In One Condition
                      for (const filter of filter) {
                        if (filter[1] === "contains" || filter[1] === "=") {
                          const finalFilter = {};
                          finalFilter[filter[0]] =
                            filter[1] === "contains" || filter[1] === "="
                              ? filter[2]
                              : filter[2];

                          // Header Filter - Gather In One Condition
                          const filterExist = this.multipleFilters.find(
                            (item) => item[filter[0]]
                          );
                          if (!filterExist)
                            this.multipleFilters.push(finalFilter);
                          else filterExist[filter[0]].push(filter[2][0]);
                        }
                      }
                    }
                  } // -------------- Header Filter --------------------
                }
                if (
                  filter.length > 0 &&
                  filter[0] &&
                  filter[0] !== "Actions" &&
                  !orExist &&
                  !andExist
                ) {
                  if (filter[1] === "contains" || filter[1] === "=") {
                    const finalFilter = {};
                    finalFilter[filter[0]] =
                      filter[1] === "contains" || filter[1] === "="
                        ? filter[2]
                        : filter[2];

                    // Header Filter - Gather In One Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) this.multipleFilters.push(finalFilter);
                    else filterExist[filter[0]].push(filter[2][0]);
                  }
                } else if (andExist) {
                  for (const andFilter of filter) {
                    if (
                      andFilter.length > 0 &&
                      andFilter[0] &&
                      andFilter[0] !== "Actions"
                    ) {
                      if (andFilter[1] === "contains" || andFilter[1] === "=") {
                        const finalFilter = {};
                        finalFilter[andFilter[0]] =
                          andFilter[1] === "contains" || andFilter[1] === "="
                            ? andFilter[2]
                            : andFilter[2];
                        this.multipleFilters.push(finalFilter);
                      }
                    }
                  }
                }
              }
          }

          finalFilterObject =
            this.multipleFilters && this.multipleFilters.length > 0
              ? Object.assign({}, ...this.multipleFilters)
              : finalFilterObject;

          this.filterExportObject = finalFilterObject;
          this.sortExportObject = sortObject;

          console.log(
            "fffff",
            finalFilterObject,
            JSON.stringify(finalFilterObject)
          );

          let queryParams = {
            filterBy: finalFilterObject,
            orderBy: sortObject ? sortObject : { sortField: null },
          };

          this.isLoading = true;
          return Api()
            .get(
              `/integration/${this.getIntegId}/tempUsers/duplicate/${this.userDetails.id}/${this.currentEntity.owner_id}${params}`,
              {
                params: queryParams,
              }
            )
            .then((data) => {
              const dataArr = [];
              let i = 1;
              let arr = JSON.parse(JSON.stringify(data.data));
              arr.map((user) => {
                user.error = JSON.parse(user.errors);
                user.radioGroup = i.toString();
                // user.radioId = j.toString();
                // j++;
                user.error.map((item) => {
                  item.radioGroup = i.toString();
                  //   item.radioId = j.toString();
                });
                i++;
                // j++;
              });
              arr.map((user) => {
                dataArr.push({
                  dir_int_id: user.dir_int_id,
                  email: user.email,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  phone: user.phone,
                  id: user.id,
                  rfid_number: user.rfid_number,
                  user_id: user.user_id,
                  user_user_id: user.user_user_id,
                  user_type: user.user_type
                    ? Object.values(JSON.parse(user.user_type))[0]
                    : "-",
                  userType: user.user_type ? JSON.parse(user.user_type) : "",
                  errorMsg: this.$t("integrations.duplicatesFound"),
                  radioGroup: user.radioGroup,
                  selectedAction: "Select Action",
                  //   radioId: user.radioId,
                  //   user_type_id: Object.keys(JSON.parse(user.user_type))[0],
                  //   requiredError: JSON.parse(user.errors).error.required,
                  //   invalidError: JSON.parse(user.errors).error.invalid,
                  errors: user.error,
                  selected: user.id + "&&" + user.radioGroup,
                  selectedUser: user.id,
                });
              });

              // this.isServerSideExport = data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
              this.finalFilterObject = finalFilterObject;
              this.sortObject = sortObject ? sortObject : { sortField: null };
              this.usersWithDuplicatesCount = data.totalCount;
              // this.$store.commit("integration/setUsersWithDuplicatesCount", data.totalCount);
              this.isLoading = false;
              return {
                data: dataArr,
                totalCount: data.totalCount,
                summary: data.data.summary,
                groupCount: data.data.length,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
        // eslint-disable-next-line no-unused-vars
      }),
      buttonData: ["Excel", "CSV", "PDF"],
      dataGridRef,
      title: "Integrations",
      update: true,
      submitted: false,
      userPhone: null,
      currentPhone: false,
      userCountryCode: null,
      form: {
        user: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          image: null,
          user_type_id: null,
          rfid_number: null,
          user_user_id: null,
          //   system_user: false,
          department_id: null,
          role_id: null,
        },
        entity: {
          entity_id: null,
        },
      },
      selectedUser: "",
      selectedAction: "",
      selectedActionString: "",
      fullName: "",
      id: "",
      dir_int_id: "",
      items: [
        {
          text: this.$t("sideNavbarMenu.integration.text"),
          to: { name: "addIntegration" },
        },
      ],
    };
  },

  validations: {
    form: {
      user: {
        first_name: { required },
        last_name: { required },
        email: {
          required: requiredIf(function () {
            const {
              form: {
                user: { phone },
              },
            } = this;
            return !phone;
          }),
        },
        phone: {},
        user_type_id: { required },
        user_user_id: { required },
      },
    },
    userPhone: {
      required: requiredIf(function () {
        const {
          form: {
            user: { email, phone },
          },
        } = this;
        return !email && !phone;
      }),
      numeric,
    },
  },

  methods: {
    ...mapActions("dailyLogbook", ["fetchUserTypes"]),
    ...mapActions("integration", [
      "fetchTempUsersWithDuplicates",
      "fixTempUsersWithDuplicates",
      "redirectUser",
      "redirectToIntegrationSettings",
      "redirectType",
      "awaitIntegrationWithMapping",
    ]),
    ...mapActions("modal", ["onResetModal", "setData"]),
    ...mapActions("userType", ["fetchAllUserType"]),
    // ...mapActions("users", ["updateUserAction"]),

    // ...mapActions("integration", ["StartSyncUsers"]),
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },

    radioChanged(data, event) {
      const row = this.rowsData.find(
        (item) => item.radioGroup == event.split("&&")[1]
      );
      row.selectedUser = event.split("&&")[0];
      console.log("radiochanged", data, event);
    },

    getErr(data) {
      const errMsg = data.duplicate_type
        ? Object.values(data.duplicate_type).join(", ")
        : "";
      // console.log('msg', errMsg);
      return errMsg;
    },

    redirectUser() {
      this.nextLoading = true;
      this.redirectType({ id: this.getIntegId }).then(() => {
        this.nextLoading = false;
      });
    },

    redirectUserToIntegrationSettings() {
      this.redirectToIntegrationSettings();
    },

    onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Duplicates.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Duplicates.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF("landscape");
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
        }).then(() => {
          doc.save("Duplicates.pdf");
        });
      }
    },

    clearFilter() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },

    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },

    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },

    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },
  },

  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("dailyLogbook", ["getUserTypes"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("authfack", ["userDetails"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getFromView",
      //   "getSyncStatusText",
      //   "getSyncStatusStage",
      //   "getSyncStatusmsg",
      //   "getValidUsers",
      //   "getValidUsersCount",
      //    "getMigrateStatusText",
      //   "getMigrateStatusStage",
      //   "getMigrateStatusmsg",
      "getIntegId",
      "getIntgDataMapping",
      "getUsersWithDuplicates",
      "getUsersWithDuplicatesCount",
      "getIntgData",
    ]),
    ...mapGetters("userType", ["getAllUsersTypes"]),
    // ...mapGetters("users", ["getLoading"]),

    dataGrid() {
      return this.$refs[dataGridRef].instance;
    },

    rowsData() {
      let i = 1;
      //   let j = 1000000;
      if (this.getUsersWithDuplicates && this.getUsersWithDuplicates.length > 0)
        this.getUsersWithDuplicates.map((user) => {
          user.error = JSON.parse(user.errors);
          user.radioGroup = i.toString();
          // user.radioId = j.toString();
          // j++;
          user.error.map((item) => {
            item.radioGroup = i.toString();
            //   item.radioId = j.toString();
          });
          i++;
          // j++;
        });
      return this.getUsersWithDuplicates &&
        this.getUsersWithDuplicates.length > 0
        ? this.getUsersWithDuplicates.map((user) => {
            return {
              dir_int_id: user.dir_int_id,
              email: user.email,
              first_name: user.first_name,
              last_name: user.last_name,
              phone: user.phone,
              id: user.id,
              rfid_number: user.rfid_number,
              user_id: user.user_id,
              user_user_id: user.user_user_id,
              user_type: user.user_type
                ? Object.values(JSON.parse(user.user_type))[0]
                : "-",
              userType: user.user_type ? JSON.parse(user.user_type) : "",
              errorMsg: "Duplicates Found.",
              radioGroup: user.radioGroup,
              selectedAction: "Select Action",
              //   radioId: user.radioId,
              //   user_type_id: Object.keys(JSON.parse(user.user_type))[0],
              //   requiredError: JSON.parse(user.errors).error.required,
              //   invalidError: JSON.parse(user.errors).error.invalid,
              errors: user.error,
              selected: user.id + "&&" + user.radioGroup,
              selectedUser: user.id,
            };
          })
        : [];
    },
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchUserTypes().then(data => {
      data.data.map((userType) => {
        this.userTypeHeaderFilter.push({
          text: userType.name,
          value: ["user_type", "contains", [userType.id]],
        });
      });
    });
  },
  async mounted() {
    if (this.$route.query.id) {
      this.$store.dispatch("integration/setFromView", true);
      await this.awaitIntegrationWithMapping({ id: this.$route.query.id });
    }
    this.fetchTempUsersWithDuplicates(this.getIntegId);
    this.fetchAllUserType();

    setTimeout(() => {
      console.log(
        "mounted count",
        //   this.getIntegId,
        // this.getUsersWithDuplicates,
        this.getUsersWithDuplicatesCount
      );
    }, 3000);
    if (this.getIntgDataMapping) {
      this.items.push(
        {
          text: this.getIntgDataMapping.name,
          to: {
            name: "viewIntegration",
            params: {
              integId: this.getIntegId,
              integName: this.getIntgDataMapping.name,
            },
          },
          // active: true,
        },
        {
          text: this.$t("integrations.duplicateList"),
          // to: { name: "viewIntegration" },
          active: true,
        }
      );
    }
  },

  destroyed() {
    // this.$store.commit("integration/setLoading", false);
  },

  watch: {
    getModalState(state) {
      state == true &&
        this.$bvModal.hide("add-edit-user") &&
        this.$bvModal.hide("actionDuplicates" + this.selectedActionString);
    },
  },

  created() {
    console.log("rowsData", this.rowsData);
    document.addEventListener("mousedown", (e) => {
      if (e.path) {
        // console.log("path", e.path);
        let isColumnChooser = false;
        for (let i = 0; i < e.path.length; i++) {
          if (typeof e.path[i].matches == "function") {
            if (e.path[i].matches(".dx-overlay-content")) {
              isColumnChooser = true;
            }
          }
        }
        if (!isColumnChooser) this.dataGrid.hideColumnChooser();
      }
    });
  },
};
</script>

<template>
  <div>
    <!-- already fixed -->
    <b-modal
      id="alreadyFixedDuplicate"
      hide-footer
      size="lg"
      scrollable
      hide-header
      no-close-on-backdrop
    >
      <div>
        <h3 class="signIn-out-header">Duplicate fixed</h3>

        <p class="all-paragraphs">
          This duplicate has been fixed by another system user.
        </p>

        <hr />

        <div class="btn-container">
          <button
            class="confirmation-btn"
            @click="$bvModal.hide('alreadyFixedDuplicate')"
          >
            Okay
          </button>
        </div>
      </div>
    </b-modal>

    <VpFormLayout>
      <template v-slot:content-header>
        <Breadcrumb
          v-if="getFromView"
          style="background-color: transparent"
          :items="items"
        />
        <PageHeader v-else :title="title" />
      </template>
      <template v-slot:content-body>
        <!-- grid -->
        <section
          class="dashboard-grid duplicates-grid white-bg-sec"
          v-if="usersWithDuplicatesCount || usersWithDuplicatesCount == 0"
        >
          <div class="data-grrid">
            <div class="header-content">
              <div class="d-flex error-count" style="margin-bottom: 15px">
                <h5>{{ $t("integrations.importedWithDuplicates") }}</h5>
                <span
                  class="count-alignment"
                  :class="{ 'count-zero': usersWithDuplicatesCount == 0 }"
                  >{{ usersWithDuplicatesCount }}</span
                >
              </div>

              <p
                class="note"
                v-if="!getFromView && usersWithDuplicatesCount > 0"
              >
                <b>{{ $t("common.notes.note") }}: </b
                >{{ $t("integrations.importNote") }}
                <span class="text-capitalize"> {{ getIntgData.dir_code }}</span
                >. {{ $t("integrations.importNote2") }}
              </p>
              <p
                class="note"
                v-if="getFromView && usersWithDuplicatesCount > 0"
              >
                <b>{{ $t("common.notes.note") }}: </b
                >{{ $t("integrations.importNote") }}
                <span class="text-capitalize"> {{ getIntgData.dir_code }}</span
                >. {{ $t("integrations.importNote3") }}
              </p>
            </div>
            <DxDataGrid
              v-show="!isLoading"
              id="dupGridContainer"
              :ref="dataGridRef"
              :data-source="dataStore"
              :remote-operations="true"
              :rtl-enabled="rtlEnabled"
              :showBorders="false"
              :columnAutoWidth="true"
              :allowColumnReordering="true"
              :allowColumnResizing="true"
              :rowAlternationEnabled="false"
              :showColumnLines="true"
              :showRowLines="true"
              :repaint-changes-only="true"
              :two-way-binding-enabled="true"
              :no-data-text="usersWithDuplicatesCount ? 'No data' : ''"
              @row-updated="updateRow($event)"
              @content-ready="contentReady($event)"
              @editor-preparing="onEditorPreparing($event)"
              :class="{ 'no-content': usersWithDuplicatesCount == 0 }"
            >
              <!-- <DxEditing :use-icons="true" :allow-updating="true" :allow-adding="false" :allow-deleting="false" mode="row" /> -->
              <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
              <DxPaging
                :page-size="10"
                :visible="usersWithDuplicatesCount > 0"
              />
              <DxPager
                :visible="usersWithDuplicatesCount > 0"
                :allowed-page-sizes="[5, 10, 25, 50, 100, 'all']"
                :display-mode="'full'"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="true"
                :infoText="$t('common.page')"
              />

              <!-- <DxSelection mode="multiple"/> -->

              <DxFilterRow :visible="true" />
              <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

              <DxHeaderFilter :visible="true" />

              <!-- <DxSearchPanel :visible="true" placeholder="Search..."/> -->

              <DxColumnChooser
                :enabled="true"
                mode="select"
                :title="$t('common.grid.columnChooser')"
              />

              <DxExport :enabled="true" :allow-export-selected-data="false" />

              <DxToolbar>
                <!-- <DxItem name="columnChooserButton" location="before" /> -->
                <DxItem location="before" template="columnButtonTemplate" />
                <DxItem template="exportButtonTemplate" location="before" />
                <DxItem template="clearAllTemplate" location="before" />
              </DxToolbar>

              <!-- <DxGrouping :context-menu-enabled="true"/>
          <DxGroupPanel :visible="true"/> -->
              <DxColumn
                caption=""
                cell-template="radioButton-cell"
                :width="96"
                alignment="end"
                :allow-exporting="false"
                :show-in-column-chooser="false"
              />

              <DxColumn
                data-field="first_name"
                :caption="$t('common.firstName')"
                :width="166"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="last_name"
                :caption="$t('common.lastName')"
                :width="151"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="email"
                :caption="$t('common.emailAddress')"
                :width="201"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="phone"
                :caption="$t('common.phoneNumber')"
                :width="201"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="user_id"
                :caption="$t('common.id')"
                :width="200"
                alignment="start"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="rfid_number"
                :caption="$t('common.RFID')"
                :width="200"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="user_type"
                :caption="$t('common.userType')"
                :width="200"
                :allow-filtering="false"
                :allow-header-filtering="true"
              >
                <DxHeaderFilter :data-source="userTypeHeaderFilter" />
              </DxColumn>

              <DxColumn
                data-field="errorMsg"
                :caption="$t('common.error')"
                cell-template="error-cell"
                :allow-filtering="false"
                :allow-exporting="false"
                :allow-editing="false"
                :width="215"
              />

              <DxColumn
                :caption="$t('common.grid.actions')"
                cell-template="action-cell"
                :allow-filtering="false"
                :allow-exporting="false"
                :allow-editing="false"
                :min-width="200"
                css-class="select-actions custom-duplicatesActions"
              >
                <DxHeaderFilter :allow-search="false" />
              </DxColumn>

              <template #clearAllTemplate>
                <div
                  v-if="showClearAll"
                  class="clear-cols d-flex align-items-center"
                >
                  <div class="toolbar-custom-line"></div>
                  <Button
                    :text="$t('common.grid.clearFilters')"
                    @click="clearFilter"
                    styling-mode="outlined"
                    type="danger"
                    class="clear-CustomColums"
                  />
                </div>
              </template>

              <template #exportButtonTemplate>
                <DxDropDownButton
                  class="export-dropdown"
                  :items="buttonData"
                  :text="$t('common.grid.export')"
                  @item-click="onItemClick"
                />
              </template>

              <template #columnButtonTemplate>
                <button
                  class="custom-columns"
                  @click="dataGrid.showColumnChooser()"
                >
                  <span class="custom-text"
                    >{{ $t("common.grid.columns") }}
                  </span>

                  <span class="custom-icon">
                    <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
                  </span>
                </button>
              </template>

              <template #error-cell="{ data }">
                <div>
                  <div class="error-value">
                    {{ data.value }}
                  </div>
                </div>
              </template>

              <template #action-cell="{ data }">
                <dublicateAction
                  :dublicatesData="data.data"
                  @refreshGrid="dataGrid.refresh()"
                />
              </template>

              <template #radioButton-cell="{ data }">
                <b-form-group
                  class="custom-radios custom-activeRadio"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio
                    v-model="data.data.selected"
                    :aria-describedby="ariaDescribedby"
                    :name="data.data.radioGroup"
                    :value="data.data.id + '&&' + data.data.radioGroup"
                    v-on:change="radioChanged(data, $event)"
                    :checked="data.data.radioChecked"
                  >
                  </b-form-radio>
                </b-form-group>
              </template>

              <DxMasterDetail :enabled="true" template="master-detail" />
              <template #master-detail="{ data }">
                <div>
                  <!-- <h5 class="master-detail-caption text-dark">Scans</h5> -->
                  <DxDataGrid
                    :rtl-enabled="rtlEnabled"
                    :data-source="data.data.errors"
                    :showBorders="false"
                    :columnAutoWidth="true"
                    :allowColumnReordering="true"
                    :allowColumnResizing="true"
                    :rowAlternationEnabled="true"
                    :showColumnLines="true"
                    :showRowLines="true"
                    :showColumnHeaders="false"
                  >
                    <DxColumn
                      caption=""
                      cell-template="radioButton-cell"
                      :width="85"
                    />

                    <DxColumn
                      data-field="first_name"
                      caption="First Name"
                      :width="168"
                    />

                    <DxColumn
                      data-field="last_name"
                      caption="Last Name"
                      :width="150"
                    />

                    <DxColumn
                      data-field="email"
                      caption="Email Address"
                      :width="200"
                    />

                    <DxColumn
                      data-field="phone"
                      caption="Phone Number"
                      :width="200"
                    />

                    <DxColumn
                      data-field="user_user_id"
                      caption="ID"
                      :width="200"
                    />

                    <DxColumn
                      data-field="rfid_number"
                      caption="RFID"
                      :width="200"
                    />

                    <DxColumn
                      data-field="user_type"
                      caption="User Type"
                      :width="200"
                    />

                    <DxColumn
                      caption="Error"
                      cell-template="error-cell"
                      :width="800"
                    />

                    <template #radioButton-cell="{ data }">
                      <b-form-group
                        class="custom-radios custom-activeRadio"
                        v-slot="{ ariaDescribedby }"
                      >
                        <b-form-radio
                          v-model="data.data.selected"
                          :aria-describedby="ariaDescribedby"
                          :name="data.data.radioGroup"
                          :value="
                            data.data.user_id + '&&' + data.data.radioGroup
                          "
                          v-on:change="radioChanged(data, $event)"
                          checked
                        ></b-form-radio>
                      </b-form-group>
                    </template>

                    <template #error-cell="{ data }">
                      <div>
                        <div class="error-value">
                          {{ getErr(data.data) }}
                        </div>
                      </div>
                    </template>
                  </DxDataGrid>
                </div>
              </template>
            </DxDataGrid>
          </div>
          <div
            class="table-extension"
            v-if="!isLoading && usersWithDuplicatesCount == 0"
          >
            <h4 class="duplicates-solved">Duplicates already solved</h4>
            <p class="sync-msg" v-if="!getFromView">
              Press<b>"Next"</b>to continue your first sync process
            </p>
          </div>

          <div class="action-btns" v-if="!getFromView">
            <button
              class="submit-btn btn btn-primary"
              size="md"
              @click="redirectUserToIntegrationSettings()"
            >
              <span>Back</span>
            </button>
            <button
              class="submit-btn btn btn-primary mb-5"
              size="md"
              :disabled="
                nextLoading || getLoading || usersWithDuplicatesCount > 0
              "
              @click="redirectUser"
            >
              <i
                v-if="nextLoading || getLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span>Next</span>
            </button>
          </div>
        </section>
      </template>
    </VpFormLayout>
  </div>
</template>

<style lang="scss" scoped>
.action-btns {
  // margin-top: 64px;
  // padding-bottom: 64px;
  .submit-btn {
    margin-inline-end: 15px !important;
  }
}
.custom-columns {
  margin-inline-start: -11px !important;
}
.error-value {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  color: #f46a6a !important;
}

.header-content {
  width: 100%;
  background: white;
  padding-bottom: 1px;
  padding-top: 40px;
}
.table-extension {
  width: 100% !important;
  height: 304px !important;
  background: white !important;
  text-align: center !important;
  padding-top: 79px !important;
  h4.duplicates-solved {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #495057;
    padding-bottom: 22px;
  }
  .sync-msg {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #939393;
  }
}
.count-zero {
  width: 38px !important;
  height: 29px !important;
}
.count-alignment {
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-selectSize {
  width: 140px !important;
  height: 27px !important;
}
.note {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  padding-inline-start: 4px;
  // padding-top:15px;
}
@import "@/design/user_form_modals.scss";
.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}
.delete-icon {
  font-size: 1.3rem;
  margin-inline-start: 8px;
  cursor: pointer;
}
.user-types-select {
  z-index: 1100;
}
.user-roles {
  z-index: 999;
}
p {
  display: block;
  color: #939393;
}
.header-close {
  font-size: 24px !important;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5.modal-title {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.error-count {
  padding-inline-start: 4px;
  h5 {
    font-weight: 900;
    font-size: 20px;
    line-height: 24px;
    color: #939393;
    opacity: 0.46;
  }
  span {
    width: 47px;
    height: 29px;
    // padding-top: 2px !important;
    text-align: center;
    background-color: #f46a6a;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    border-radius: 15.5px !important;
    margin-inline-start: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 15px;
  border-right-color: #d9d9d9;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 36px;
  // padding-top: 32px;
}
</style>
<style lang="scss">
section.dashboard-grid.duplicates-grid.white-bg-sec {
  .custom-control-label {
    position: absolute !important;
  }
  .custom-activeRadio .custom-radio .custom-control-label::before {
    background-color: #c7c7c7 !important;
    width: 20px !important;
    height: 20px !important;
    border: none !important;
  }
}
div#alreadyFixedDuplicate___BV_modal_content_ {
  width: 579px !important;
  margin-top: 150px;
  border-radius: 26px !important;
  h3.signIn-out-header {
    color: #000;
    font-size: 17px;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 40px;
  }
  h3.signIn-out-status {
    color: #787878;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 155%;
    margin-bottom: 16px;
  }
  p.all-paragraphs {
    color: var(--939393, #939393);
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 175.5%;
    margin-bottom: 0px !important;
  }
  hr {
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    border: 0;
    border-top: 1px solid #707070;
    opacity: 0.15;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    button.confirmation-btn {
      width: 112px;
      height: 33px;
      border-radius: 16.5px;
      background: #103f5e;
      border: none;
      color: #fff;
      text-align: center;

      font-size: 16px;

      font-weight: 400;
      line-height: normal;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      //margin-inline-end: 15px;
    }
  }
}
div#dupGridContainer {
  .dx-datagrid {
    height: unset;
  }
  td.dx-cell-focus-disabled.dx-master-detail-cell {
    background-color: white;
    .dx-datagrid-header-panel {
      margin-inline-start: 15px !important;
    }
  }
  .dx-datagrid-rowsview .dx-master-detail-row > .dx-master-detail-cell {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  min-height: 350px !important;
}
.dashboard-grid {
  border-start-start-radius: 6px !important;
  tbody {
    color: #495057;
  }
}
.no-content {
  .dx-scrollable-scroll-content,
  .dx-scrollable-container {
    display: none !important;
  }
}
.custom-duplicatesActions {
  ul.dropdown-menu.show {
    align-items: center !important;
    background: #ffffff !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 6px !important;
    text-align: center !important;
    min-width: 140px !important;
    min-height: 78px !important;
    margin-top: 6px !important;
  }
  a.dropdown-item {
    margin: auto !important;

    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    text-align: center !important;
    color: #787878 !important;
    padding-inline-end: 30px !important;
  }
}

button#__BVID__99__BV_toggle_ ul.dropdown-menu.show {
  text-align: center !important;
  text-align: center;
  width: 30px !important;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%) !important;
  border-radius: 6px !important;
  margin-top: 6px !important;
}

div#actionDuplicatesMerge___BV_modal_content_ {
  width: 579px !important;
  margin-top: 170px;
  border-radius: 26px;
  // height: 275.38px !important;
  h4.modal-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    text-align: start !important;
    margin-bottom: 35px !important;
  }
  .modal-paragraph {
    font-weight: 400;
    font-size: 20px !important;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;
    margin-bottom: 35.75px !important;
    .bold-word {
      font-weight: 700 !important;
    }
  }

  .line {
    width: 488.16px !important;
    height: 1px !important;
    opacity: 0.15;
    background: #707070;
  }
  .modal-buttonSize {
    width: 111.69px !important;
    height: 33.26;
    margin-top: 20px !important;
    // margin-bottom: 20px !important;
  }
  .action-btns {
    margin-top: 0 !important;
  }
}
div#actionDuplicatesSkip___BV_modal_content_ {
  width: 579px !important;
  margin-top: 150px;
  border-radius: 26px;
  // height: 312px !important;
  h4.modal-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    text-align: start;
    margin-bottom: 35px !important;
  }
  .modal-paragraph {
    font-weight: 400;
    font-size: 20px !important;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.25px;
    margin-bottom: 8px;
    color: #939393;
    .bold-word {
      font-weight: 700 !important;
    }
  }
  .modal-smallParagraph {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;
    margin-bottom: 21px !important;
  }
  .line {
    width: 488.16px !important;
    height: 1px !important;
    opacity: 0.15;
    background: #707070;
  }
  .modal-buttonSize {
    width: 111.69px !important;
    height: 33.26;
    margin-top: 20px !important;
  }
  .action-btns {
    margin-top: 0 !important;
  }
}
</style>
